import CityServiceTemplate from "@/components/CityServiceTemplate";
import seguinHero from "@/assets/cities/seguin-hero.jpg";

const CarServiceSeguin = () => {
  return (
    <CityServiceTemplate
      cityName="Seguin"
      cityDescription="Professional black car service for Seguin area business and leisure travelers. From corporate meetings to airport transfers, we deliver premium transportation with every ride."
      metaDescription="Luxury car service in Seguin, TX. Executive transportation, airport service, and chauffeur for business and leisure. Rick's Black Car Service."
      canonicalPath="/seguin-car-service"
      heroImage={seguinHero}
      additionalContent="Seguin professionals and visitors rely on Rick's Black Car Service for dependable luxury transportation. Whether you're traveling to San Antonio for business, need SAT Airport service, or require transportation for special events, our chauffeurs ensure a first-class experience."
      coordinates={{
        latitude: 29.5688,
        longitude: -97.9778
      }}
      serviceRadius="40 miles"
      featuredPricing={{
        route: "Seguin ↔ SAT Airport",
        price: "~40 mi",
        note: "Pricing based on distance & time (includes 20% gratuity)"
      }}
      cityReviews={[
        {
          author: "Richard Thompson",
          rating: 5,
          date: "2024-11-18",
          text: "I use Rick's service regularly for business travel from Seguin to San Antonio. Consistently professional, the Audi is always spotless, and Rick's route knowledge saves valuable time. Excellent service!"
        },
        {
          author: "Nancy Rodriguez",
          rating: 5,
          date: "2024-10-08",
          text: "Rick provided transportation for our Seguin wedding party. He was incredibly organized, punctual, and made sure everyone arrived safely and on time. Can't recommend him enough!"
        }
      ]}
    />
  );
};

export default CarServiceSeguin;
